module.exports = __webpack_public_path__ + "media/images/smart_phone/products/ninjin1-d728fa88c031e44bc2d3542cd4314c60.jpeg";